import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import * as _ from 'lodash';
import { MSFilterClass } from "./MSFilterClass";
import { CommonFunctions } from '../../static/common-functions';
/************************************************************
 * Multi Select Combo Selector 
 * And creates custom unique list from grid of only items
 * in grid.
 ************************************************************/
export class MSCLFilterClass extends MSFilterClass {
    constructor(fieldName: string, gridFieldName: string, gridData: any[]) {
        super(fieldName);
        this.processGridData(gridFieldName, gridData);
    }
    customList: string[]
    processGridData(gridFieldName: string, gridData: any[]) {
        let tempData: any[] = _.uniq(_.map(gridData, gridFieldName));
        this.customList = tempData;
        if (CommonFunctions.hasArrayValue(tempData)) {
            this.customList = tempData.sort();
        }
    }
}
